import { Component, ViewChild, OnInit, ChangeDetectorRef } from '@angular/core';
import { NavbarControl, InPageNavigateNavbarItem, setAngularCoreModuleNavbar } from '@lmnop/angular-core';
import { Router, NavigationEnd, Event } from '@angular/router';
import { setAngularWebsiteCoreModuleNavbar } from '@lmnop/angular-website-core';
import { IoCContainer } from '@lmnop/web-core';
import { AppIoCKeys, ClearLocalStorageModule, IAppIoCContainer } from 'app-src';

@Component({
    selector: 'app-component',
    templateUrl: './app.component.html',
    standalone: false,
})
export class AppComponent implements OnInit {
    constructor(
        private router: Router,
        private crd: ChangeDetectorRef
    ) {}

    @ViewChild('navbar', { static: true })
    private navbar: NavbarControl;

    private ioc: IAppIoCContainer;
    // protected coreService: ICoreServiceIoCContainer;

    public ngOnInit(): void {
        // this.coreService = IoCContainer.get(CoreServiceIoCKeys.ICoreServiceIoCContainer);
        this.ioc = IoCContainer.get(AppIoCKeys.IAppIoCContainer);

        this.router.events.forEach((event: Event): void => {
            if (event instanceof NavigationEnd) {
                this.navbar.clearNavbarItems();
                setAngularCoreModuleNavbar(event.urlAfterRedirects, this.navbar);
                setAngularWebsiteCoreModuleNavbar(event.urlAfterRedirects, this.navbar);

                if (event.urlAfterRedirects.toLowerCase().includes('home')) {
                    // new InPageNavigateNavbarItem('home_page.social', 'social')
                    this.navbar.items = [new InPageNavigateNavbarItem('home_page.development', 'development'), new InPageNavigateNavbarItem('home_page.extensions', 'extensions')];
                }
                this.crd.detectChanges();
                this.navbar.initNavbar();
            }
        });

        // this.ioc.core.eventHandler.on(Diagnostic.ERROR_SAVED_TO_LOCAL_STORAGE, (eventArgs: OnErrorSavedToLocalStorageEventArgs): void => {
        //     let notificationText: string = '';
        //     let buttonText: string = '';
        //     if (eventArgs.translationMissing) {
        //         buttonText = 'Missing translation';
        //         notificationText = `It looks like a translation is missing. Please send us with pressing the '` + buttonText + `' button`;
        //     } else {
        //         buttonText = 'Send Error';
        //         notificationText = `It looks like an error happend. Please send us the errormessage pressing the '` + buttonText + `' button`;
        //     }
        //     //in this low level error handling we don't do translations
        //     let noifiationOption: NotificationOption = this.ioc.core.notificationService.createOption(notificationText, NotificationLevel.danger);
        //     this.ioc.core.notificationService.notify(noifiationOption);
        //     this.developerBar.showBar();
        //     this.developerBar.addButton(
        //         'sendClientSideError',
        //         () => {
        //             this.sendClientSideError();
        //         },
        //         buttonText,
        //         'btn btn-primary'
        //     );
        // });
    }

    public ngAfterViewInit(): void {
        // this.initSidebar();
    }

    // private sendClientSideError(): void {
    // TODO
    // let model: LogClientExceptionMessageModel = new LogClientExceptionMessageModel();
    // model.clientDetails = Debugger.getClientDetails();
    // model.clientShortName = this.ioc.settings.core.applicationShortName;
    // model.errorMessage = Debugger.getErrorFromLocalStorage();
    // this.ioc.core.notificationService.closeAllMessages();
    // this.coreService.exceptionLoggerService.logClientExceptionMessage(model).then(() => {
    //     Debugger.clearErrorFromLocalStorage();
    //     this.developerBar.removeButton('sendClientSideError');
    // });
    // }

    initSidebar(): void {
        this.ioc.core.sidebarManager.integrationId = 'wecdev-website';
        this.ioc.core.sidebarManager.integrationModules.push(new ClearLocalStorageModule());
        this.ioc.core.sidebarManager.showSidebars();
    }
}
